export default __webpack_public_path__ + "static/media/logo.3fe6a0e5.svg";